import { useIntl } from "react-intl";

import FeatureHighlight from "@/components/wpl/feature-highlight/src";

const FeaturesSection = () => {
    const intl = useIntl();

    const featureCards = [
        {
            label: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.knowledge-management-label",
                defaultMessage: "Knowledge Management"
            }),
            title: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.centralize-information-title",
                defaultMessage: "Centralize information"
            }),
            body: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.centralize-information-body",
                defaultMessage:
                    "Organize everything in one space, from projects to company policies and beyond."
            }),
            contentSrc:
                "https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/confluence-product-tour/borderless_features.mp4"
        },
        {
            label: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.project-collaboration-label",
                defaultMessage: "Project collaboration"
            }),
            title: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.coordinate-title",
                defaultMessage: "Coordinate plans & make decisions"
            }),
            body: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.coordinate-body",
                defaultMessage:
                    "Keep everyone up to speed by connecting project plans to status updates."
            }),
            contentSrc:
                "https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/confluence-product-tour/video_project-collaboration.mp4"
        },
        {
            label: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.company-wide-collaboration-label",
                defaultMessage: "Company-wide collaboration"
            }),
            title: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.connect-work-title",
                defaultMessage: "Connect work across teams"
            }),
            body: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.connect-work-body",
                defaultMessage:
                    "Collaborate across teams with comments, mentions, notifications, and co-editing."
            }),
            contentSrc:
                "https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/confluence-product-tour/video_collaboration.mp4"
        }
    ];

    return (
        <FeatureHighlight
            header={intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.header",
                defaultMessage:
                    "Build, organize, and collaborate on work in one place from virtually anywhere"
            })}
            background="lightblue"
            barColor="p100"
            cards={featureCards}
        />
    );
};

export default FeaturesSection;
